module.exports = {
	"account.user.driving.licence.already.exist": "Er is nog een account met dit rijbewijsnummer.",
	"account.user.login.already.exist": "Dit e-mailadres wordt al gebruikt door een ander account.",
	"account.user.suspended": "Deze actie kan niet worden uitgevoerd omdat de gebruiker is opgeschort",
	"action.add.payment": "Betaalmethode toevoegen",
	"action.complete.my.account": "Maak mijn account compleet",
	"action.confirm.welcome.msg": "Laten we gaan",
	"action.create.my.account": "Maak mijn account",
	"action.search.update.bookings": "Controleer de beschikbaarheid",
	"action.update.payment": "Betaalmethode bijwerken",
	"anonymous.search.location.not.available": "The search is not available for this location",
	"booking.accept_usage_terms.link.label": "Terms of use",
	"booking.accept_usage_terms.text": "Door op \"Bevestigen\" te klikken, verklaart u op erewoord de servicevoorwaarden te aanvaarden en momenteel in het bezit te zijn van een geldig rijbewijs als u gebruikmaakt van de autodeelservice. Meer in de {link}.",
	"booking.accept_usage_terms.title": "Gebruiksvoorwaarden",
	"booking.action.cancel.forbidden": "U kunt de boeking niet meer annuleren",
	"booking.action.edit.forbidden": "U kunt een boeking niet meer bewerken",
	"booking.add.calendar": "Toevoegen aan agenda",
	"booking.confirm": "Boeking bevestigen",
	"booking.confirm_and_pay": "Bevestigen en betalen",
	"booking.deposit": "Waarborgsom",
	"booking.deposit.b": "Er wordt een bankdeposito van {damageSafetyDeposit} {currency} in rekening gebracht wanneer u uw reservering bevestigt.\n Deze borg kan worden gebruikt om eventuele schade aan het voertuig tijdens uw reis te dekken. \n\n Als het voertuig zonder schade of overuren wordt geretourneerd, wordt alleen de prijs van {bookingPrice} {currency} in rekening gebracht.",
	"booking.deposit.d": "Een bankdeposito van {bufferPrice} {currency} zal worden gedaan wanneer u uw reservering bevestigt.\n Dit is inclusief de prijs van uw reservering en een toeslag om eventuele overschrijdingen te dekken. \n\n Zonder overschrijding of voertuigschade wordt alleen {bookingPrice} {currency} van uw rekening afgeschreven.",
	"booking.deposit.db": "Er worden twee bankdeposito's in rekening gebracht wanneer u uw reservering bevestigt:\n — Eerste van het bedrag van {bufferPrice} {currency} , inclusief de prijs van uw reservering en een toeslag om eventuele overschrijdingen te dekken.\n — Tweede bedrag van {damageSafetyDeposit} {currency} om eventuele schade aan het voertuig tijdens uw reservering te dekken. \n\n Zonder enige overschrijding of schade aan het voertuig, wordt alleen {bookingPrice} {currency} in rekening gebracht.",
	"booking.deposit.info": "Er wordt een aanbetaling gedaan voor uw boeking",
	"booking.payment.prebilling.refused.error": "De transactie is geweigerd, omdat de afschrijving van uw creditcard is mislukt. Herhaal met een andere kaart. Neem contact op met uw bank als het probleem zich blijft voordoen.",
	"booking.payment.prebilling.technical.error": "Er is een fout opgetreden tijdens de betaling. Probeer het later opnieuw.",
	"booking.success.sub.title": "Bedankt voor het gebruiken van onze service!",
	"booking.success.title": "Gefeliciteerd, uw boeking is gelukt!",
	"booking.type.label": "Reserveringstype",
	"booking.type.one_way": "Enkele reis",
	"booking.type.return_trip": "Heen- en terugreis",
	"booking.update.period.expired": "De periode voor het bijwerken van de boekingsdatums is verlopen",
	"booking.usage.business": "Zakelijk",
	"booking.usage.private": "Privé",
	"booking.view_payment_terms.title": "Betalingsvoorwaarden",
	"booking.voucher.different.code": "U kunt uw promotiecode niet wijzigen",
	"booking.voucher.placeholder": "Ik heb een vouchercode",
	"car.AUTOMATIC": "Automatisch",
	"car.DIESEL": "Diesel",
	"car.ELECTRIC": "Elektrisch",
	"car.FOLDING_SEATS": "Opklapbare zitplaatsen",
	"car.GPS": "GPS",
	"car.HYBRID": "Hybride",
	"car.LPG": "GPL",
	"car.MANUAL": "Handmatig",
	"car.PETROL": "Benzine",
	"car.RADIO_CD": "Radio",
	"car.booking_details": "Reserveringsgegevens",
	"car.color": "Kleur",
	"car.compact_cars": "Compact",
	"car.description": "Description",
	"car.details": "Voertuiggegevens",
	"car.doors": "Deuren",
	"car.filter.COMMERCIAL": "Commercieel",
	"car.filter.PASSENGER": "Toerisme",
	"car.filter.accessories.air_conditioning": "Airconditioning",
	"car.filter.accessories.baby_seat": "Baby seat",
	"car.filter.accessories.bluetooth": "Bluetooth",
	"car.filter.accessories.large_truck": "Grote vrachtwagen",
	"car.filter.accessories.radio_cd": "Radio",
	"car.filter.label_nb_persons": "Aantal personen",
	"car.filter.other": "Andere",
	"car.filter.other-nb": "Overige - {nb}",
	"car.filter.vehicle_type": "Voertuigtype",
	"car.filter_energy": "Energie",
	"car.filter_gearbox_type": "Type versnellingsbak",
	"car.filter_persons": "mensen",
	"car.for_every_additional_km": "Per extra kilometer",
	"car.km_included": "Km inbegrepen",
	"car.motorization": "Motorisering",
	"car.options": "Opties",
	"car.parking_additional_info": "Parkeerspecifieke details",
	"car.places": "Zitplaatsen",
	"car.pricing": "Prijsstelling",
	"car.pricing.estimate": "Prijsschatting",
	"car.pricing.extra_km_cost_per_day": "Prijs voor extra km",
	"car.pricing.free_km_per_day": "Km inclusief / 24 uur",
	"car.specifications": "Specificaties",
	"car.transmission": "Transmissie",
	"car.utility_cars": "Nut",
	"car.version": "Versie",
	"company.id.missing.booking.search": "Het bedrijfs-ID is verplicht voor het anoniem zoeken naar reserveringen",
	"contact_page.phone_call_price": "(BEL GRATIS MET EEN VAST TELEFOONNUMMER)",
	"contact_page.title_1": "Voor vragen over uw huurauto,",
	"contact_page.title_2": "twijfel niet om per e-mail contact met ons op te nemen.",
	"creditcard.data.insufficient.3ds": "Vanwege nieuwe 3DS2-vereisten vragen we u om uw betalingsgegevens bij te werken.",
	"custom.field.type.boolean": "Ja/Nee",
	"data.with.colon": "{data}:",
	"document.issue.date": "Uitgiftedatum",
	"dropzone.inner.info": "Toegestane bestanden: JPEG, PNG, PDF",
	"dropzone.inner.title": "Upload uw document",
	"error.booking.member_invalid": "Uw profiel is nog niet gevalideerd.",
	"error.booking.no.usage": "Geen gebruik voor deze boekingsdata",
	"error.booking.no_credit_card": "Voeg eerst uw creditcardgegevens toe.",
	"error.booking.same_period": "U heeft al een reservering gepland voor deze periode.",
	"error.change_password.400.bad_request": "Wachtwoord onjuist",
	"error.contract.inactive": "De service is niet actief voor uw bedrijf, neem contact op met uw servicemanager.",
	"error.contract.not-found": "De service is door uw bedrijf opgeschort, neem contact op met uw servicemanager.",
	"error.credit.card.refused": "Creditcard geweigerd",
	"error.forgot_password.404": "Controleer uw e-mail, geen accountovereenkomsten",
	"error.form.email.already_exists": "Voer een ander e-mailadres in",
	"error.form.email_invalid": "Voer een geldig e-mailadres in",
	"error.form.inviteCode.notEmpty": "Voer een uitnodigingscode in",
	"error.form.password.at_least": "Uw wachtwoord moet minimaal 8 tekens lang zijn",
	"error.form.password.at_most": "Uw wachtwoord mag maximaal 25 tekens bevatten",
	"error.form.password.cannot_reset_same": "Uw nieuwe wachtwoord moet anders zijn dan het huidige",
	"error.form.password.digit": "Uw wachtwoord moet 1 cijfer bevatten",
	"error.form.password.lower_letter": "Uw wachtwoord moet 1 kleine letter bevatten",
	"error.form.password.upper_letter": "Uw wachtwoord moet 1 hoofdletter bevatten",
	"error.form.password_confirmation.the_same": "Voer twee keer hetzelfde wachtwoord in",
	"error.form.password_old.the_same": "Het nieuwe wachtwoord moet anders zijn dan de vorige gebruikte wachtwoorden",
	"error.form.required": "Vul alle verplichte velden in",
	"error.form.suggestion.address.required": "Selecteer het adres uit de lijst met suggesties",
	"error.form.technical": "Technische fout",
	"error.get.site.config": "Kan siteconfiguratie niet laden",
	"error.invite.code.invalid": "De community waarvan je lid wilt worden, bestaat niet",
	"error.login.401.unauthorized": "Uw e-mail of wachtwoord is onjuist",
	"error.login.403.user.anonymized": "Uw account wordt geanonimiseerd, u kunt het niet meer gebruiken",
	"error.login.422.user.not.enabled": "Uw account is niet geactiveerd. Controleer uw e-mails en volg de instructies om uw account te activeren.",
	"error.number.above.max": "De waarde kan niet meer zijn dan {value}",
	"error.number.below.min": "De waarde kan niet lager zijn dan {value}",
	"error.phone.format.invalid": "De notatie van het telefoonnummer is onjuist",
	"error.register.without.sso": "You can only subscribe using SSO",
	"error.request_error": "Verzoekfout",
	"error.reset_password.401": "De aangeboden link is niet langer geldig, vraag een ander wachtwoord aan op de site",
	"error.search.vehicles.403": "Je hebt geen toegang tot de geselecteerde site met het huidige actieve profiel",
	"error.session.expired": "Sessie verlopen",
	"error.text.length.long": "Dit veld is beperkt tot {count} tekens",
	"error.text.length.short": "Dit veld moet minstens {count} tekens bevatten",
	"error.user.verify.fail": "User verification failed",
	"error_profile_edit_member_approved": "Naam en geboortedatum kunnen niet worden gewijzigd nadat uw profiel is gevalideerd",
	"faq.contactEmailFallback": "ons contact e-mailadres",
	"faq.contactPhoneFallback": "onderaan de pagina",
	"faq.other_question": "Kunt u het antwoord op uw vraag niet vinden?",
	"file_upload_size_exceeded": "Het bestand is te groot. Maximumgrootte: 5 MB",
	"footer.label.legal.information": "Legale informatie",
	"footer.label.personal.data": "Persoonlijke gegevens",
	"footer_callUs": "Bel ons",
	"footer_other": "Andere",
	"footer_share": "Volg ons",
	"footer_society_about": "Over ons",
	"footer_society_policy_privacy": "Privacybeleid",
	"footer_society_term": "Gebruiksvoorwaarden",
	"footer_writeUs": "Laat een e-mail achter",
	"forgot_password.confirmation": "Er is een link naar uw e-mailadres gestuurd om uw wachtwoord opnieuw in te stellen.",
	"forgot_password.description_line1": "Voer het e-mailadres in dat aan uw account is gekoppeld.",
	"forgot_password.description_line2": "We sturen u een link om uw wachtwoord opnieuw in te stellen.",
	"forgot_password.submit": "Stuur mij reset link",
	"generic.address": "Adres",
	"generic.at": "om",
	"generic.book": "Reserveren",
	"generic.cancel": "Annuleren",
	"generic.canceled": "Geannuleerd",
	"generic.city": "Plaats",
	"generic.clear": "Wissen",
	"generic.company": "Bedrijf",
	"generic.completed": "Voltooid",
	"generic.country": "Land",
	"generic.email": "E-mail",
	"generic.end": "Einde",
	"generic.expires.at": "Vervalt",
	"generic.extend": "Verlengen",
	"generic.file": "Bestand",
	"generic.first.name": "Voornaam",
	"generic.last.name": "Achternaam",
	"generic.location.fixture.label": "Sites",
	"generic.location.history.label": "Geschiedenis",
	"generic.location.search.placeholder": "Zoek naar een adres, een plaats ...",
	"generic.mobile.phone": "Mobiele telefoon",
	"generic.modify": "Wijzigen",
	"generic.mr": "Dhr.",
	"generic.mrs": "Mevr.",
	"generic.next": "Volgende",
	"generic.number": "Nummer",
	"generic.passport": "Paspoort",
	"generic.past.placeholder": "Vind hier uw eerdere boekingen",
	"generic.phone.number": "Telefoonnummer",
	"generic.postal.code": "Postcode",
	"generic.retry": "Opnieuw proberen",
	"generic.save": "Opslaan",
	"generic.send": "Verzenden",
	"generic.start": "Start",
	"generic.text": "Tekst",
	"generic.today": "Vandaag",
	"generic.upcoming": "Aankomende",
	"generic.updated": "Bijgewerkt",
	"generic.user": "Gebruiker",
	"get.sso.config.fail": "This email address is not recognized for SSO login",
	"helpPage_carSharing_issue1_answer": "Om je aan te melden ga je simpelweg naar het intranet van het bedrijf, waar je een link zult vinden die je naar de aanmeldingsinterface brengt. (Of stuur een aanmeldingsverzoek naar {contactEmail}). Je zult een e-mail met de link ontvangen.",
	"helpPage_carSharing_issue1_title": "Hoe te registreren? ",
	"helpPage_carSharing_issue2_answer": "Je kunt je wachtwoord resetten vanuit de website of mobiele apps: je zult in dit geval een link ontvangen op je geregistreerde e-mailadres om je nieuwe wachtwoord in te stellen. ",
	"helpPage_carSharing_issue2_title": "Wat als ik mijn wachtwoord ben vergeten? ",
	"helpPage_carSharing_issue3_answer": "In het geval dat je je badge hebt verloren of een nieuwe hebt gekregen, neem dan alsjeblieft contact op met het Callcentrum via {contactPhone} om je badge te resetten. Een nieuwe badge zal pas werken wanneer deze gereset is.",
	"helpPage_carSharing_issue3_title": "Wat als ik mijn badge ben verloren of een nieuwe heb? ",
	"helpPage_carSharing_issue4_answer": "Het kentekennummer van je voertuig staat vermeld in the bevestigingsmail en -sms. Je kunt het voertuig anders altijd terugvinden op de boekingswebsite onder Mijn Boekingen. ",
	"helpPage_carSharing_issue4_title": "Welk voertuig heb ik geboekt? ",
	"helpPage_carSharing_issue5_answer": "Zorg ervoor dat de datum en tijd kloppen aangezien de startknop enkel beschikbaar is vanaf het moment dat de boeking ingaat. Anders kun je je badge langs de kaartlezer halen om de deuren van het voertuig te openen. ",
	"helpPage_carSharing_issue5_title": "Waarom kan ik de startknop niet vinden? ",
	"helpPage_carSharing_issue6_answer": "Indien je een reservering hebt gemaakt en het licht gaat op groen maar de deur wordt niet geopend, druk dan op de knop op de hendel van de deur. ",
	"helpPage_carSharing_issue6_title": "Waarom is er een groen licht maar zijn de deuren nog steeds gesloten? ",
	"helpPage_carSharing_issue7_answer": "Wanneer je het voertuig eenmaal geboekt hebt kun je je reservering ook aanpassen of annuleren via de website of mobiele applicatie. Indien je ondersteuning nodig hebt, bel dan het Callcentrum via {contactPhone}.",
	"helpPage_carSharing_issue7_title": "Aanpassen / Annuleren",
	"helpPage_carSharing_issue8_answer": "Je kunt niet van tevoren badgen en kunt het voertuig pas openen op het moment van je boeking. ",
	"helpPage_carSharing_issue8_title": "Kan ik de badge van tevoren erlangs halen? ",
	"helpPage_damages_issue1_answer": "Zorg ervoor dat je voordat je begint met je reservering een melding maakt van de schade via de mobiele app of door het Callcentrum te bellen via {contactPhone}.",
	"helpPage_damages_issue1_title": "Wat te doen bij de beschadiging van een gereserveerd voertuig?",
	"helpPage_damages_issue2_answer": "Blijf rustig en controleer of er niemand gewond is. Je wordt gedekt door de verzekering. Neem alsjeblieft zo snel mogelijk contact op met het Callcentrum op {contactPhone} voor verdere instructies.",
	"helpPage_damages_issue2_title": "Wat te doen bij een ongeval tijdens mijn reservering? ",
	"helpPage_subtitle": "In deze sectie kun je de antwoorden op de meest gestelde vragen vinden.",
	"helpPage_tab_carSharing": "Dienst",
	"helpPage_tab_damages": "Schade",
	"helpPage_tab_vehicles": "Voertuig",
	"helpPage_title": "Veelgestelde vragen (FAQ)",
	"helpPage_vehicles_issue1_answer": "Controleer je reserveringsdata en -uren en dan of het kentekennummer overeenkomt met jouw boeking. Sleep vervolgens ENKEL je badge langs de lezer. Zorg ervoor dat je de badge gebruikt die tot dezelfde persoon behoort als degene die de boeking heeft gedaan, en dat dit niet is veranderd na de laatste boeking. In het geval van een recente switch van badge kun je contact opnemen met de klantendienst om direct een verandering door te voeren. ",
	"helpPage_vehicles_issue1_title": "Waarom reageert het voertuig niet? ",
	"helpPage_vehicles_issue2_answer": "Controleer je reserveringsdata- en uren en controleer vervolgens of het kentekennummer overeenkomt met die van je boeking. Zorg ervoor dat je de juiste badge in bezit hebt (de badge van de persoon die de reservering heeft gemaakt). ",
	"helpPage_vehicles_issue2_title": "Waarom laat de kaartlezer enkel rood licht zien? ",
	"helpPage_vehicles_issue3_answer": "Wanneer je een boeking hebt en het licht is groen maar je hoort de deuren niet ontgrendelen, druk dan op de knop op de deur aan de kant van de bestuurder om de deuren te openen. ",
	"helpPage_vehicles_issue3_title": "Waarom blijven de deuren dicht? ",
	"helpPage_vehicles_issue4_answer": "Controleer de kentekenplaat van het voertuig en je data en tijden, en zorg ervoor dat je voldoende internetverbinding hebt. ",
	"helpPage_vehicles_issue4_title": "Waarom kan ik de deuren niet openen? ",
	"helpPage_vehicles_issue5_answer": "Zorg er gewoon voor dat de motor uit staat, dat de deuren en achterklep goed dicht zitten en dat je de sleutels met het kleine fiche die in het doosje in het dashboardkastje zit hebt afgegeven.",
	"helpPage_vehicles_issue5_title": "Waarom kan ik het voertuig niet op slot doen? ",
	"home.header_banner": "In oktober wordt <strong> Renault Mobility </strong> <strong> Mobilize share </strong>",
	"home.welcome": "Welkom bij {productName}",
	"home.welcome_solo": "Welkom",
	"how_it_works.step_1": "<span class='bold'>Download applicatie</span> uit de App Store of Google Play.",
	"how_it_works.step_2": "Start de applicatie en <span class='bold'>registreer</span> door het formulier in te vullen.",
	"how_it_works.step_3": "Maak een foto van uw <span class='bold'>rijbewijs</span>, uw <span class='bold'>identiteitskaart</span> en <span class='bold'>maak een foto van uzelf</span> met uw identiteitskaart naast uw gezicht, bewaar het allemaal in de app!",
	"how_it_works.step_4": "<span class='bold'> Registreer uw bankkaart </span> om de betaling van uw huur te beheren.",
	"how_it_works.step_5": "<span class='bold'>Valideer uw e-mailadres</span> door op de link te klikken die naar u is verzonden. <span class='bold'>Controleer uw SPAM-mappen</span>.",
	"how_it_works.step_6": "Zodra uw registratie is gevalideerd, <span class='bold'>reserveert u uw voertuig</span> in onze applicatie of op onze website. Op de dag van uw reservering is <span class='bold'>uw smartphone uw sleutel!</span>",
	"info.account.company.already.linked": "Dit bedrijf is al aan uw account gekoppeld",
	"info.switch.profile": "<strong>New — </strong>You can now add and manage multiple profiles using the same credentials. This allows you to join corporate fleets of you company and use the same app to rent a vehicle for your week-ends.",
	"info.switching.profile": "Van profiel wisselen",
	"info.worldpay.return.success": "Betalingsinformatie bijgevoegd",
	"iso__BE": "België",
	"iso__CS": "Tsjechië",
	"iso__DA": "Deens",
	"iso__DE": "Duitsland",
	"iso__ES": "Spanje",
	"iso__FR": "Frankrijk",
	"iso__IT": "Italië",
	"iso__NL": "Nederland",
	"iso__PL": "Polen",
	"iso__PT": "Portugal",
	"iso__SL": "Slovenië",
	"iso__SV": "Zweden",
	"iso__pt_BR": "Brazilië",
	"label.accept_terms_and_conditions": "Ik ga ermee akkoord dat Renault en zijn netwerk vervolgens per e-mail contact met mij opnemen voor onderzoek of informatie over nieuwe producten en actuele aanbiedingen. Bij elke verzending zal ik de mogelijkheid hebben om alle communicatie te beëindigen.",
	"label.account.already.active": "Uw account is al actief",
	"label.account_activation_description": "U ontvangt een bevestiging per e-mail wanneer uw account is gevalideerd en u kunt dan volledig profiteren van de service.",
	"label.account_activation_title": "Uw account wordt binnen maximaal 15 minuten gevalideerd.",
	"label.activation.link.expired": "De activeringslink is verlopen",
	"label.activation.link.send": "Opnieuw versturen",
	"label.activation.link.sent.success": "De activatie-e-mail wordt verzonden als de gebruiker bestaat en het account niet is geactiveerd",
	"label.active.profile": "Actief profiel",
	"label.actual.payment.method": "Uw huidige betaalmethode",
	"label.add.new.profile": "Nieuw profiel toevoegen",
	"label.apply": "Toepassen",
	"label.are_you_sure_you_want_to_cancel": "Wilt u uw annulering bevestigen?",
	"label.birth.day": "Geboortedatum",
	"label.booking": "Boeking",
	"label.booking.past": "Verleden",
	"label.booking.past.placeholder": "Vind hier uw boekingsgeschiedenis.",
	"label.booking.today.part": "vandaag om",
	"label.booking.upcoming.placeholder": "Vind hier uw geplande en lopende boekingen",
	"label.cancel_my_booking": "Annuleer mijn reservering",
	"label.car": "voertuig",
	"label.carSharing": "Auto delen",
	"label.cars": "voertuigen",
	"label.civility": "Beleefdheid",
	"label.click_here": "Klik hier",
	"label.close": "Sluiten",
	"label.confirm_new_password": "Bevestig wachtwoord",
	"label.congratulations": "Gefeliciteerd!",
	"label.continue": "Doorgaan",
	"label.creditCard_message": "Om uw kaart te valideren, wordt er een tijdelijke afschrijving uitgevoerd. Een afschrijving van een klein bedrag {amountToTake} € kan tijdelijk verschijnen op de rekening die aan uw kaart is gekoppeld. Neem contact op met uw bank als de afschrijving langer dan vijf werkdagen aanhoudt.",
	"label.date": "Datum",
	"label.delivery_place": "Stad van uitgifte",
	"label.driving_licence": "Rijbewijs",
	"label.driving_licence_back": "Rijbewijs (achterkant)",
	"label.driving_licence_front": "Rijbewijs (voorkant)",
	"label.edit.invite.code": "Uitnodigingscode bewerken",
	"label.expiration_date": "Vervaldatum",
	"label.file.upload.only.mobile": "Gebruik de mobiele app om documenten te bewerken.",
	"label.filter_by": "Filter op",
	"label.filters": "Filters",
	"label.generic.error": "Er is een fout opgetreden. Probeer het later opnieuw.",
	"label.hours": "uren",
	"label.how_it_works": "Hoe werkt het?",
	"label.identity.card": "Identiteitskaart",
	"label.identity.document.number": "Nummer identiteitsbewijs",
	"label.identity.document.type": "Type identiteitsbewijs",
	"label.identity_card": "Identiteitsbewijs",
	"label.identity_card_back": "Identiteitsbewijs (achterkant)",
	"label.identity_card_front": "Identiteitsbewijs (voorkant)",
	"label.identity_card_selfie": "Selfie met uw identiteitsbewijs",
	"label.invite_code_placeholder": "Voer uw uitnodigingscode in",
	"label.italy.fiscal.code": "Voer fiscaal nummer in",
	"label.italy.resident": "Ben je Italiaans?",
	"label.licence_number": "Rijbewijsnummer",
	"label.load_more": "Meer resultaten",
	"label.login": "Log in",
	"label.logout": "Uitloggen",
	"label.manager.email": "E-mail van uw manager",
	"label.mandatory_fields": "* Verplichte velden",
	"label.member_already": "Al lid ?",
	"label.my_account": "Mijn account",
	"label.my_reservations": "Mijn reserveringen",
	"label.new.password": "Nieuw wachtwoord",
	"label.no_account": "Nieuw lid ?",
	"label.or_by_phone": "Of telefonisch",
	"label.password": "Wachtwoord",
	"label.password_forgot": "Wachtwoord vergeten",
	"label.phone": "Telefoon",
	"label.phone.suffix": "Telefoon doorkiesnummer",
	"label.plateNumber": "Plaat nummer",
	"label.price": "prijs",
	"label.redirectMobileApp": "Download onze mobiele app om uw boeking te starten!",
	"label.remember_me": "Blijf ingelogd",
	"label.reset_password_done": "Uw wachtwoord is bijgewerkt",
	"label.return": "Terug",
	"label.schedule": "Uren",
	"label.search": "Zoeken",
	"label.selected.language": "Geselecteerde taal",
	"label.subject": "Onderwerp",
	"label.switch.profile": "Van profiel wisselen",
	"label.the": "tot",
	"label.validate": "Valideer",
	"label.vehicles_found": "{count} resultaten gevonden",
	"label.warning": "Waarschuwing",
	"label.welcome.finish.registration": "Rond uw registratie af om uw afspraak te bevestigen.",
	"label.you_are_trying_to_cancel_your_booking": "U staat op het punt uw reservering te annuleren!",
	"label.your.active.profile": "Je actieve profiel",
	"label.your.other.profiles": "Je andere profielen",
	"label.your_message": "Uw bericht",
	"language.header": "Selecteer uw taal",
	"login.forgot_password": "Uw wachtwoord vergeten ?",
	"login.register": "Registreren",
	"menu.faq": "Info",
	"mobile_banner.text": "Download de {productName} -applicatie",
	"page.password.update.sub.title": "Om veiligheidsredenen vragen wij u uw wachtwoord bij te werken",
	"page.password.update.title": "Wachtwoord update",
	"parking.special_opening_legend": "Speciale openingstijden",
	"part.company.fill.extra.info": "vraagt u om wat aanvullende informatie in te vullen.",
	"part.complete.register.for": "Voltooi uw registratie voor",
	"part.create.account.for": "Maak een account aan voor",
	"part.link.account.to": "Koppel je account aan",
	"part.your.email": "jouw email",
	"placeholder.enter.number": "Voer een nummer in ...",
	"placeholder.enter.text": "Typ hier ...",
	"placeholder.search": "Zoeken ...",
	"profile.422.error.info": "Het lijkt erop dat er informatie ontbreekt in uw profiel.\n Laten we samen uw profiel verifiëren om er zeker van te zijn dat alles in orde is.",
	"profile.info.new.email": "Als u uw e-mailadres bijwerkt, ontvangt u een e-mail om uw e-mailadres te verifiëren. Zonder deze te verifiëren, kunt u geen boeking meer doen.",
	"profile.label.before.arrival": "Voor de aankomst",
	"profile.label.before.departure": "Voor het vertrek",
	"profile.label.charges.call.center": "Voor vanwege mij gemaakte aanpassingen",
	"profile.label.charges.my": "Voor door mij gemaakte aanpassingen",
	"profile.label.current.password": "Huidig wachtwoord",
	"profile.label.expiration.date.status": "Mijn rijbewijs heeft geen vervaldatum",
	"profile.label.min.15": "15 minuten",
	"profile.label.min.30": "30 minuten",
	"profile.label.min.45": "45 minuten",
	"profile.label.new.email": "Nieuw e-mailadres",
	"profile.label.street.field": "Adres (huisnummer + straatnaam)",
	"profile.label.validated.email": "Uw gevalideerde e-mailadres",
	"profile.section.additional.info": "Extra informatie",
	"profile.section.credentials": "Inloggegevens",
	"profile.section.language": "Profieltaal",
	"profile.section.notifications": "Meldingen en waarschuwingen",
	"profile.section.payment.info": "Betalingsinformatie",
	"profile.section.personal.info": "Persoonlijke informatie",
	"profile.section.selfie": "Selfie",
	"profile.section.technician.access": "Toegang voor technici",
	"profile.select.menu.item": "Selecteer een menu-item aan de linkerkant",
	"profile.selfie.section.info": "Maak alstublieft een selfie met uw identiteitskaart naast uw gezicht.",
	"profile.suspended": "Je profiel is opgeschort",
	"profile.title.email.notifications": "E-mailmeldingen",
	"profile.title.language.select": "Taal die wordt gebruikt voor meldingen en e-mails",
	"profile.title.sms.notifications": "SMS-meldingen",
	"profile.title.update.email": "Update uw e-mailadres",
	"profile.title.update.password": "Update uw wachtwoord",
	"profile_error_driver_license_invalid": "Het rijbewijs is niet geldig",
	"register.field.info.password": "Moet minstens 1 cijfer, 1 hoofdletter, 1 kleine letter en tussen 8 en 25 tekens bevatten",
	"register.info.payment.saved": "Betaalmethode is opgeslagen.",
	"register.info.profile.creation.forbidden": "You can't link your profile to this company",
	"register.success.info": "Er is een activeringslink verzonden naar {email}. Controleer uw mail en spammap en volg de instructies om uw account te activeren voordat de link verloopt.",
	"register.terms.ads": "Ik geef toestemming voor de verwerking van mijn gegevens voor marketingdoeleinden (met zowel geautomatiseerde als traditionele methoden) in verband met mobiliteitsproducten en/of -diensten",
	"register.terms.prefix.accept": "Ik accepteer de",
	"register.terms.privacy.link.label": "Privacy policy",
	"register.terms.privacy.text": "I accept the {link} of {company}",
	"register.terms.root.privacy": "privacybeleid",
	"register.terms.root.tos": "voorwaarden van abonnement",
	"register.terms.root.tou": "gebruiksvoorwaarden",
	"register.terms.suffix.ads": "gebruik van mijn gegevens voor commerciële doeleinden",
	"register.terms.suffix.of": "van",
	"register.terms.usage.link.label": "Terms of use",
	"register.terms.usage.subscription.link.label": "Terms of subscription",
	"register.terms.usage.subscription.text": "I accept the {link} of {company}",
	"register.terms.usage.text": "I accept the {link} of {company}",
	"register.title.account.created": "Gefeliciteerd {firstName}, je account is aangemaakt",
	"register.title.account.linked": "Gefeliciteerd {firstName}, nieuw profiel is gekoppeld aan uw account",
	"register.title.account.updated": "Gefeliciteerd {firstName}, uw account is bijgewerkt",
	"reset_password.title": "Wachtwoord reset",
	"search.filter_alphabetically": "Alfabetische volgorde",
	"search.filter_by": "Sorteer op",
	"search.filter_by_price": "Op prijs",
	"search.result.empty": "Er is geen resultaat",
	"service.corporate.intro": "Wilt u lid worden van een community? Voer uw uitnodigingscode in.",
	"service.intro_label": "Op welke {productName}-service wilt u zich abonneren?",
	"service.private.intro": "U wilt een voertuig uit het netwerk van {productName} reserveren?",
	"service.private.renaultfr": "Download de app in uw mobiele winkel om u te abonneren op {productName}.",
	"service.private.select_country": "Selecteer een land",
	"service.usage.corporate": "Zakelijk autodelen",
	"service.usage.private": "24/7 autoverhuur",
	"service.usage.vr": "Vervangend voertuig",
	"service.vr.intro": "Bedankt voor uw interesse in onze service! \n\nOm lid te worden, dient u contact op te nemen met uw dealer voor een registratielink.",
	"sncf.home.login.msg": "Are you an SNCF employee? Log in.",
	"sso.login.description": "Voer je zakelijke e-mailadres in",
	"sso.login.title": "Maak verbinding met SSO",
	"status.APPROVED": "Profiel gevalideerd",
	"status.NOT_APPROVED": "Je profiel is afgewezen. Werk uw profiel bij.",
	"status.TO_COMPLETE": "Onvolledig",
	"status.TO_REVIEW": "Uw profiel wacht op validatie",
	"tagline": "24/7 self-service autoverhuur",
	"title.add.payment.later": "U kunt het later toevoegen.",
	"title.add.payment.method": "Voeg een betaalmethode toe.",
	"title.bookings.welcome.tutorial": "Vind hier uw boeking, deze is al ingepland",
	"title.modify.booking": "Mijn reservering wijzigen",
	"title.password.change.success": "Je nieuwe wachtwoord werd opgeslagen",
	"title.update.booking": "Boeking bijwerken",
	"title.welcome.to.brand": "Hallo {firstName}, welkom bij {brandName}.",
	"title.welcome.to.program": "Hallo {firstName}, welkom bij het programma {brandName} {program}.",
	"vehicle.incorrect.usage": "Het voertuig is niet beschikbaar voor dit gebruikstype",
	"week.day.friday": "Vrijdag",
	"week.day.monday": "Maandag",
	"week.day.saturday": "Zaterdag",
	"week.day.sunday": "Zondag",
	"week.day.thursday": "Donderdag",
	"week.day.tuesday": "Dinsdag",
	"week.day.wednesday": "Woensdag"
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/i18n/nl.json
 ** module id = 425
 ** module chunks = 0
 **/